/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { GeneratedRoute } from '@elegant-router/types';

export const generatedRoutes: GeneratedRoute[] = [
  {
    name: '403',
    path: '/403',
    component: 'layout.blank$view.403',
    meta: {
      constant: true,
      title: '403',
      i18nKey: 'route.403',
      hideInMenu: true
    }
  },
  {
    name: '404',
    path: '/404',
    component: 'layout.blank$view.404',
    meta: {
      title: '404',
      i18nKey: 'route.404',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '500',
    path: '/500',
    component: 'layout.blank$view.500',
    meta: {
      title: '500',
      i18nKey: 'route.500',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'affiliate',
    path: '/affiliate',
    component: 'layout.base$view.affiliate',
    meta: {
      constant: true,
      title: 'affiliate',
      icon: 'hugeicons:computer-dollar',
      i18nKey: 'route.affiliate',
      order: 20,
      footer: true
    }
  },
  {
    name: 'api-keys',
    path: '/api-keys',
    component: 'layout.base$view.api-keys',
    meta: {
      title: 'api-keys',
      icon: 'icon-park-outline:api',
      i18nKey: 'route.api-keys',
      order: 6
    }
  },
  {
    name: 'billing',
    path: '/billing',
    component: 'layout.base',
    meta: {
      title: 'billing',
      icon: 'icon-park-outline:computer-one',
      i18nKey: 'route.billing',
      order: 3
    },
    children: [
      {
        name: 'billing_addresses',
        path: '/billing/addresses',
        component: 'view.billing_addresses',
        meta: {
          title: 'billing_addresses',
          icon: 'icon-park-outline:local-two',
          i18nKey: 'route.billing_addresses',
          order: 5
        }
      },
      {
        name: 'billing_credit',
        path: '/billing/credit',
        component: 'view.billing_credit',
        meta: {
          title: 'billing_credit',
          icon: 'icon-park-outline:credit',
          i18nKey: 'route.billing_credit',
          order: 1
        }
      },
      {
        name: 'billing_history',
        path: '/billing/history',
        component: 'view.billing_history',
        meta: {
          title: 'billing_history',
          icon: 'icon-park-outline:history-query',
          i18nKey: 'route.billing_history',
          order: 3
        }
      },
      {
        name: 'billing_invoices',
        path: '/billing/invoices',
        component: 'view.billing_invoices',
        meta: {
          title: 'billing_invoices',
          icon: 'icon-park-outline:bill',
          i18nKey: 'route.billing_invoices',
          order: 4
        }
      },
      {
        name: 'billing_packages',
        path: '/billing/packages',
        component: 'view.billing_packages',
        meta: {
          title: 'billing_packages',
          icon: 'icon-park-outline:creative',
          i18nKey: 'route.billing_packages',
          order: 2
        }
      }
    ]
  },
  {
    name: 'calculator',
    path: '/calculator',
    component: 'layout.base$view.calculator',
    meta: {
      title: 'calculator',
      icon: 'icon-park-outline:calculator',
      i18nKey: 'route.calculator',
      order: 3,
      constant: true
    }
  },
  {
    name: 'home',
    path: '/home',
    component: 'layout.base$view.home',
    meta: {
      constant: true,
      title: 'home',
      icon: 'icon-park-outline:data-screen',
      i18nKey: 'route.home',
      order: 1,
      guestViewable: true,
      authRequiredActions: ['create-api-key', 'modify-settings']
    }
  },
  {
    name: 'limits',
    path: '/limits',
    component: 'layout.base$view.limits',
    meta: {
      constant: true,
      title: 'limits',
      icon: 'icon-park-outline:permissions',
      i18nKey: 'route.limits',
      order: 7
    }
  },
  {
    name: 'login',
    path: '/login/:module(pwd-login|code-login|register|reset-pwd|bind-wechat)?',
    component: 'layout.blank$view.login',
    props: true,
    meta: {
      title: 'login',
      i18nKey: 'route.login',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'model-studio',
    path: '/model-studio',
    component: 'layout.base',
    redirect: {
      name: 'model-studio_overview'
    },
    meta: {
      title: 'model-studio',
      icon: 'icon-park-outline:experiment-one',
      i18nKey: 'route.model-studio',
      order: 2.5,
      constant: true
    },
    children: [
      {
        name: 'model-studio_compare',
        path: '/model-studio/compare',
        component: 'view.model-studio_compare',
        meta: {
          title: 'model-studio_compare',
          icon: 'icon-park-outline:contrast-view',
          i18nKey: 'route.model-studio_compare',
          order: 5
        }
      },
      {
        name: 'model-studio_overview',
        path: '/model-studio/overview',
        component: 'view.model-studio_overview',
        meta: {
          title: 'model-studio_overview',
          icon: 'icon-park-outline:data-screen',
          i18nKey: 'route.model-studio_overview',
          order: 1
        }
      },
      {
        name: 'model-studio_playground',
        path: '/model-studio/playground',
        component: 'view.model-studio_playground',
        meta: {
          title: 'model-studio_playground',
          icon: 'icon-park-outline:play',
          i18nKey: 'route.model-studio_playground',
          order: 2
        }
      },
      {
        name: 'model-studio_prompts',
        path: '/model-studio/prompts',
        component: 'view.model-studio_prompts',
        meta: {
          title: 'model-studio_prompts',
          icon: 'icon-park-outline:file-addition',
          i18nKey: 'route.model-studio_prompts',
          order: 3
        }
      },
      {
        name: 'model-studio_requests',
        path: '/model-studio/requests',
        component: 'view.model-studio_requests',
        meta: {
          title: 'model-studio_requests',
          icon: 'icon-park-outline:history-query',
          i18nKey: 'route.model-studio_requests',
          order: 6
        }
      },
      {
        name: 'model-studio_workflows',
        path: '/model-studio/workflows',
        component: 'view.model-studio_workflows',
        meta: {
          title: 'model-studio_workflows',
          icon: 'icon-park-outline:list-view',
          i18nKey: 'route.model-studio_workflows',
          order: 4
        }
      }
    ]
  },
  {
    name: 'models',
    path: '/models',
    component: 'layout.base$view.models',
    meta: {
      constant: true,
      title: 'models',
      icon: 'icon-park-outline:all-application',
      i18nKey: 'route.models',
      order: 2
    }
  },
  {
    name: 'sponsorship',
    path: '/sponsorship',
    component: 'layout.base',
    meta: {
      title: 'sponsorship',
      icon: 'icon-park-outline:like',
      i18nKey: 'route.sponsorship',
      order: 4
    },
    children: [
      {
        name: 'sponsorship_apply',
        path: '/sponsorship/apply',
        component: 'view.sponsorship_apply',
        meta: {
          title: 'sponsorship_apply',
          i18nKey: 'route.sponsorship_apply',
          hideInMenu: true,
          constant: true
        }
      },
      {
        name: 'sponsorship_home',
        path: '/sponsorship/home',
        component: 'view.sponsorship_home',
        meta: {
          title: 'sponsorship_home',
          icon: 'icon-park-outline:like',
          i18nKey: 'route.sponsorship_home',
          order: 0
        }
      },
      {
        name: 'sponsorship_levels',
        path: '/sponsorship/levels',
        component: 'view.sponsorship_levels',
        meta: {
          title: 'sponsorship_levels',
          icon: 'icon-park-outline:ladder',
          i18nKey: 'route.sponsorship_levels',
          order: 2
        }
      },
      {
        name: 'sponsorship_status',
        path: '/sponsorship/status',
        component: 'view.sponsorship_status',
        meta: {
          title: 'sponsorship_status',
          icon: 'icon-park-outline:list-checkbox',
          i18nKey: 'route.sponsorship_status',
          order: 1
        }
      }
    ]
  },
  {
    name: 'support',
    path: '/support',
    component: 'layout.base',
    meta: {
      title: 'support',
      icon: 'icon-park-outline:helpcenter',
      i18nKey: 'route.support',
      order: 21,
      constant: true
    },
    children: [
      {
        name: 'support_ai-operations',
        path: '/support/ai-operations',
        component: 'view.support_ai-operations',
        meta: {
          title: 'support_ai-operations',
          icon: 'icon-park-outline:data-screen',
          i18nKey: 'route.support_ai-operations',
          order: 6,
          constant: false
        }
      },
      {
        name: 'support_all-tickets',
        path: '/support/all-tickets',
        component: 'view.support_all-tickets',
        meta: {
          title: 'support_all-tickets',
          icon: 'icon-park-outline:tickets-one',
          i18nKey: 'route.support_all-tickets',
          order: 5
        }
      },
      {
        name: 'support_create-ticket',
        path: '/support/create-ticket',
        component: 'view.support_create-ticket',
        meta: {
          title: 'support_create-ticket',
          icon: 'icon-park-outline:file-addition',
          i18nKey: 'route.support_create-ticket',
          order: 2,
          constant: false,
          guestViewable: true
        }
      },
      {
        name: 'support_dashboard',
        path: '/support/dashboard',
        component: 'view.support_dashboard',
        meta: {
          title: 'support_dashboard',
          icon: 'icon-park-outline:workbench',
          i18nKey: 'route.support_dashboard',
          order: 1,
          constant: false,
          guestViewable: true
        }
      },
      {
        name: 'support_knowledge-base',
        path: '/support/knowledge-base',
        component: 'view.support_knowledge-base',
        meta: {
          title: 'support_knowledge-base',
          icon: 'icon-park-outline:book-open',
          i18nKey: 'route.support_knowledge-base',
          order: 4,
          constant: false,
          guestViewable: true
        }
      },
      {
        name: 'support_my-tickets',
        path: '/support/my-tickets',
        component: 'view.support_my-tickets',
        meta: {
          title: 'support_my-tickets',
          icon: 'icon-park-outline:ticket',
          i18nKey: 'route.support_my-tickets',
          order: 3,
          constant: false,
          guestViewable: true
        }
      }
    ]
  },
  {
    name: 'tokenizer',
    path: '/tokenizer',
    component: 'layout.base$view.tokenizer',
    meta: {
      title: 'tokenizer',
      icon: 'icon-park-outline:code',
      i18nKey: 'route.tokenizer',
      order: 3.1,
      constant: true
    }
  },
  {
    name: 'usage',
    path: '/usage',
    component: 'layout.base',
    meta: {
      title: 'usage',
      icon: 'icon-park-outline:chart-histogram-two',
      i18nKey: 'route.usage',
      order: 5
    },
    children: [
      {
        name: 'usage_overview',
        path: '/usage/overview',
        component: 'view.usage_overview',
        meta: {
          title: 'usage_overview',
          icon: 'icon-park-outline:chart-histogram-one',
          i18nKey: 'route.usage_overview',
          order: 1
        }
      },
      {
        name: 'usage_recommendations',
        path: '/usage/recommendations',
        component: 'view.usage_recommendations',
        meta: {
          title: 'usage_recommendations',
          icon: 'icon-park-outline:tips',
          i18nKey: 'route.usage_recommendations',
          order: 3
        }
      },
      {
        name: 'usage_reports',
        path: '/usage/reports',
        component: 'view.usage_reports',
        meta: {
          title: 'usage_reports',
          icon: 'icon-park-outline:table-report',
          i18nKey: 'route.usage_reports',
          order: 2
        }
      }
    ]
  }
];
